import "./ConnectedProviders.scss";

import { memo } from "react";

import { GitHubIcon, GoogleIcon, MicrosoftIcon } from "../icons";
import { StatusIndicator } from "../StatusIndicator/StatusIndicator";

interface IProps {
  providers: string[];
}

const baseProviders: {
  icon: JSX.Element;
  name: string;
}[] = [
  {
    icon: <MicrosoftIcon />,
    name: "Microsoft",
  },
  {
    icon: <GitHubIcon />,
    name: "GitHub",
  },
  {
    icon: <GoogleIcon />,
    name: "Google",
  },
];

const ConnectionProviders: React.FC<IProps> = memo(({ providers }) => {
  return (
    <>
      {baseProviders.map(provider => {
        const isConnected = providers?.includes(provider.name);
        return (
          <div
            key={provider.name}
            data-testid={provider.name}
            className="providers-container my-5 d-flex justify-content-between align-items-center"
          >
            <div className="d-flex align-items-center providers-icon">
              {provider.icon}
              {provider.name}
            </div>
            <div>
              <StatusIndicator
                status={isConnected ? "connected" : "not-connected"}
              />
              {isConnected ? "Connected" : "Not connected"}
            </div>
          </div>
        );
      })}
    </>
  );
});

export { ConnectionProviders };
